import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import type { DomainFoldersState } from './domainFolders.types';

const getDomainFoldersState = (state: RootState): DomainFoldersState => state.domainsFolders;

export const getDomainFoldersList = createSelector(getDomainFoldersState, (state) => state.list);

export const getDomainFolderQuotaFree = createSelector(
    getDomainFoldersState,
    (folders, folderId: string) => folderId,
    (folders, folderId) => {
        const lowerFolderId = folderId.toLowerCase();
        if (folders.list[lowerFolderId]) {
            return folders.list[lowerFolderId].quota - folders.list[lowerFolderId].size;
        }

        return 0;
    }
);

export const getClosestDomainBitmask = createSelector(
    getDomainFoldersState,
    (folders, folderId: string) => folderId,
    (folders, folderId) => {
        const pathParts = folderId?.toLowerCase().split('/').filter(Boolean);
        while (pathParts?.length) {
            const domainFolder = folders.list[`/${pathParts.join('/')}`];
            if (domainFolder) {
                return isNaN(domainFolder.mode_bitmask) ? null : domainFolder.mode_bitmask;
            }
            pathParts.pop();
        }

        return null;
    }
);

export const getDomainFolderModeBitmask = createSelector(
    getDomainFoldersState,
    (folders, folderId: string) => folderId,
    (folders, folderId: string) => {
        const folder = folders.list[folderId?.toLowerCase()];
        if (!isNaN(folder?.mode_bitmask)) {
            return folder.mode_bitmask;
        }

        return -1;
    }
);
